import { render, staticRenderFns } from "./SocialCampaignCustomFields.vue?vue&type=template&id=706647b4&scoped=true&"
import script from "./SocialCampaignCustomFields.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignCustomFields.vue?vue&type=style&index=0&id=706647b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706647b4",
  null
  
)

export default component.exports